<script setup lang="ts">
import IconRightAngle from 'assets/icons/RightAngle.svg'
import IconMinus from '~/assets/icons/minus.svg'

const props = defineProps<{
  latestValue: {
    value: number
    unit: string
  }
  latestColor: {
    color: string
    colorType: string
  }
  label: string
}>()

const isNeutral = computed(() => props.latestColor.colorType === 'neutral')
const valueIsNumber = computed(() => !isNaN(props.latestValue.value))
const latestValueLabel = computed(() => {
  if (props.latestValue.value === 0) return '00.00%'
  let value = props.latestValue.value
  if (value < 0) value *= -1
  return `${value}${props.latestValue.unit}`
})
</script>

<template>
  <div
    :style="`color: ${latestColor.color};`"
    class="flex gap-x-1 md:font-semibold items-center text-xxs md:text-base"
  >
    <span>{{ latestValueLabel }}</span>
    <template v-if="valueIsNumber">
      <IconMinus v-if="isNeutral" class="size-2 md:size-3" />
      <IconRightAngle
        v-else
        class="size-2 md:size-3"
        :class="{
          'rotate-90': latestColor.colorType === 'negative',
          '-rotate-90': latestColor.colorType === 'positive',
        }"
      />
    </template>
    <span class="text-black text-xxs md:text-xs">{{ label }}</span>
  </div>
</template>
